export default __webpack_public_path__ + "static/media/Assembly Both Ways.640180f6.gif";